import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VDialog,{attrs:{"persistent":"","max-width":"400"},model:{value:(_vm.showModal),callback:function ($$v) {_vm.showModal=$$v},expression:"showModal"}},[_c(VCard,{staticClass:"text-sm-center pb-3"},[_c(VCardTitle,{staticClass:"headline"},[_c('div',{staticClass:"text-sm-center message"},[_vm._v("\n        "+_vm._s(_vm.message)+"\n      ")])]),_c(VCardText,{staticClass:"text-center"},[_c(VProgressCircular,{attrs:{"size":70,"width":7,"indeterminate":"","color":"primary"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }